import { atom } from 'jotai';
export const $RenderConfig = atom({
    isSteamingSSR: false,
});
//# sourceMappingURL=render-config.js.map